let initialState = {
  taxList: [],
};

const taxReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TAX_LIST": {
      return {
        ...state,
        taxList: action.payload,
      };
    }
    default:
      return state;
  }
};

export default taxReducer;
